/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable eqeqeq */
// eslint-disable-next-line
import React from 'react';
import { container } from 'tsyringe';
import { PengajuanPelatihanPresenter } from '../../../../../../../../data/presenters/PengajuanPelatihanPresenter';
import { PengajuanPelatihan } from '../../../../../../../../entities/PengajuanPelatihan';
import { toast } from 'react-toastify';
import history from '../../../../../../../../history';

interface IState {
  isLoading: boolean;
  pengajuanPelatihan: PengajuanPelatihan | null;
  showDialogDelete: boolean;
  selectedId: number;
  isLoadingDelete: boolean;
  isLoadingDuplicate: boolean;
  isOpenModalDuplicate: boolean;
  showDialogTolakPengajuan: boolean;
  showDialogFormTolakPengajuan: boolean;
  showDialogTerimaPengajuan: boolean;
  showDialogFormTerimaPengajuan: boolean;
  formAlasan: string;
  isLoadingApproval: boolean;
}

interface InitialState {
  state: IState;
  getDetailPengajuanPelatihan: Function;
  setShowDialogDelete: Function;
  setSelectedId: Function;
  deletePengajuanPelatihan: Function;
  setModalDuplicate: Function;
  setShowDialogTolakPengajuan: Function;
  setShowDialogFormTolakPengajuan: Function;
  setShowDialogTerimaPengajuan: Function;
  actionDialogFormTolakPengajuan: Function;
  actionDialogFormTerimaPengajuan: Function;
  setFormAlasan: Function;
  setLoadingApproval: Function;
}

const initialState = {
  state: {
    isLoading: true,
    pengajuanPelatihan: null,
    showDialogDelete: false,
    selectedId: 0,
    isLoadingDelete: false,
    isLoadingDuplicate: false,
    isOpenModalDuplicate: false,
    showDialogTolakPengajuan: false,
    showDialogFormTolakPengajuan: false,
    showDialogTerimaPengajuan: false,
    showDialogFormTerimaPengajuan: false,
    formAlasan: '',
    isLoadingApproval: false,
  },
  getDetailPengajuanPelatihan: () => {},
  setShowDialogDelete: () => {},
  setSelectedId: () => {},
  deletePengajuanPelatihan: () => {},
  setModalDuplicate: () => {},
  setShowDialogTolakPengajuan: () => {},
  setShowDialogFormTolakPengajuan: () => {},
  setShowDialogTerimaPengajuan: () => {},
  actionDialogFormTolakPengajuan: () => {},
  actionDialogFormTerimaPengajuan: () => {},
  setFormAlasan: () => {},
  setLoadingApproval: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: ManajemenPengajuanPelatihanDetailProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: true,
    isLoadingDelete: false,
    pengajuanPelatihan: null,
    showDialogDelete: false,
    selectedId: 0,
    isLoadingDuplicate: false,
    isOpenModalDuplicate: false,
    showDialogTolakPengajuan: false,
    showDialogFormTolakPengajuan: false,
    showDialogTerimaPengajuan: false,
    showDialogFormTerimaPengajuan: false,
    formAlasan: '',
    isLoadingApproval: false,
  });

  const setModalDuplicate = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isOpenModalDuplicate: value,
    }));
  };

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setLoadingDelete = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoadingDelete: value,
    }));
  };

  const getDetailPengajuanPelatihan = async (id: number) => {
    setLoading(true);

    try {
      const pengajuanPelatihanPresenter = container.resolve(
        PengajuanPelatihanPresenter
      );
      const getDetail =
        await pengajuanPelatihanPresenter.getDetailPengajuanPelatihan(id);

      const data = getDetail;

      setState((prevstate) => ({
        ...prevstate,
        pengajuanPelatihan: data,
      }));

      setLoading(false);

      return data;
    } catch (error: any) {
      console.log('error get pelatihan:', error);
      setLoading(false);
    }
  };

  const setShowDialogDelete = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogDelete: value,
    }));
  };

  const setSelectedId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      selectedId: value,
    }));
  };

  const deletePengajuanPelatihan = async () => {
    setLoadingDelete(true);

    try {
      const pengajuanPelatihanPresenter = container.resolve(
        PengajuanPelatihanPresenter
      );
      const deletePengajuanPelatihan =
        await pengajuanPelatihanPresenter.deletePengajuanPelatihan(
          state.selectedId
        );

      const data = deletePengajuanPelatihan;

      if (data.data.code == 200) {
        toast.success('Berhasil Menghapus Data Pengajuan Pelatihan.', {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        history.replace(`/admin/manajemen_pelatihan`);
        window.location.reload();
      } else {
        toast.error('Gagal Menghapus Data Pengajuan Pelatihan.', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
      setLoadingDelete(false);
      setShowDialogDelete(false);
    } catch (error: any) {
      console.log('error pelatihan:', error);
      setLoadingDelete(false);
    }
  };

  const setShowDialogTolakPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogTolakPengajuan: value,
    }));
  };

  const setShowDialogFormTolakPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogFormTolakPengajuan: value,
    }));
  };

  const setShowDialogTerimaPengajuan = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      showDialogTerimaPengajuan: value,
    }));
  };

  const actionDialogFormTolakPengajuan = async () => {
    setLoadingApproval(true);

    try {
      const pengajuanPelatihanPresenter = container.resolve(
        PengajuanPelatihanPresenter
      );
      const tolakPengajuanPelatihan =
        await pengajuanPelatihanPresenter.updateStatusPengajuanPelatihan(
          state.selectedId,
          'ditolak',
          state.formAlasan
        );

      const data = tolakPengajuanPelatihan;

      if (data.data.code == 200) {
        toast.success('Berhasil Menolak Pelatihan yang diajukan.', {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        history.replace(`/admin/manajemen_pelatihan`);
        window.location.reload();
      } else {
        toast.error('Gagal Menolak Pelatihan yang diajukan.', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
      setLoadingApproval(false);
    } catch (error: any) {
      console.log('error pelatihan:', error);
      setLoadingApproval(false);
    }
  };

  const actionDialogFormTerimaPengajuan = async () => {
    setLoadingApproval(true);

    try {
      const pengajuanPelatihanPresenter = container.resolve(
        PengajuanPelatihanPresenter
      );
      const tolakPengajuanPelatihan =
        await pengajuanPelatihanPresenter.updateStatusPengajuanPelatihan(
          state.selectedId,
          'diterima',
          ''
        );

      const data = tolakPengajuanPelatihan;

      if (data.data.code == 200) {
        toast.success('Berhasil Menerima Pelatihan yang diajukan.', {
          style: {
            boxShadow: '0px 1px 6px #019166',
          },
        });
        history.replace(`/admin/manajemen_pelatihan`);
        window.location.reload();
      } else {
        toast.error('Gagal Menerima Pelatihan yang diajukan.', {
          style: {
            boxShadow: '0px 1px 6px #F86E70',
          },
        });
      }
      setLoadingApproval(false);
    } catch (error: any) {
      console.log('error pelatihan:', error);
      setLoadingApproval(false);
    }
  };

  const setFormAlasan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      formAlasan: value,
    }));
  };

  const setLoadingApproval = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoadingApproval: value,
    }));
  };

  return (
    <ManajemenPengajuanPelatihanDetailProvider
      value={{
        state,
        getDetailPengajuanPelatihan,
        setShowDialogDelete,
        setSelectedId,
        deletePengajuanPelatihan,
        setModalDuplicate,
        setShowDialogTolakPengajuan,
        setShowDialogFormTolakPengajuan,
        setShowDialogTerimaPengajuan,
        actionDialogFormTolakPengajuan,
        actionDialogFormTerimaPengajuan,
        setFormAlasan,
        setLoadingApproval,
      }}
    >
      {children}
    </ManajemenPengajuanPelatihanDetailProvider>
  );
};

export const useDetailPengajuanPelatihanDataPengajuanPelatihanContext = () =>
  React.useContext(Context);

export default {
  useDetailPengajuanPelatihanDataPengajuanPelatihanContext,
  Provider,
};
